module.exports = __webpack_public_path__ + "img/wangyuxin.ff71fc9c.jpg";